import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import Layout from '~/src/layout/_layout';
import { getFaqArticles, EPlaces } from '~/src/api/content/faq';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getTariffsAll } from '~/src/store/actions/bundles';
import { getBannersForMainPage } from '~/src/store/actions/main';

const Main = dynamic(() => import('~/src/layout/main'), { ssr: false });
const Index = dynamic(() => import('~/src/layout/index'), { ssr: true });

class IndexPage extends Component {
    static defaultProps = {
        city: {},
        banners: [],
        banner: {},
        gift: [],
        proofs: [],
    };

    static propTypes = {
        isAuth: PropTypes.bool.isRequired,
        hostname: PropTypes.string.isRequired,
        city: PropTypes.object,
        banners: PropTypes.array,
        banner: PropTypes.object,
        gift: PropTypes.array,
        proofs: PropTypes.array,
        bannerTitleKey: PropTypes.string,
    };

    static async getInitialProps(options) {
        const { store } = options;

        const { hostname } = await initialProps(options);

        const state = store.getState();
        const { currentCity } = state.city;

        await Promise.all([
            store.dispatch(getBannersForMainPage(currentCity.domain)),
            store.dispatch(getTariffsAll(currentCity.cityId)),
        ]);

        let faq = [];

        if (state.auth.isAuth) {
            const faqData = await getFaqArticles(currentCity.domain, {
                places: [EPlaces.Main],
            });
            faq = faqData.items;
        }

        return { hostname, faq };

    }

    render() {
        const { city, hostname, isAuth, banners, faq, ...props } = this.props;

        return (
            <Layout
                title={`Интернет-провайдер Дом.ру в ${city.cityIn}`}
                description={`Официальный сайт провайдера Дом.ру в ${city.cityIn}. Подключить быстрый Интернет, Цифровое телевидение и онлайн-кинотеатр, Домофон и Видеонаблюдение. Адреса и телефоны офисов.`}
                hostname={hostname}
                withMenu={true}
                withFooter={true}
                withChat={true}
                relCanonical={`https://${hostname}/`}
                {...props}
            >
                {isAuth
                    ? <Main data-test='info' city={city} faq={faq}/>
                    : <Index
                        city={city}
                        banners={banners}
                    />
                }
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    isAuth: state.auth.isAuth,
    banners: state.main.banners,
});

export default connect(mapStateToProps)(IndexPage);
